import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';

class TextArea extends React.Component {
    onChange = e => {
        this.props.setValue(e.currentTarget.value);
    };
    render() {
        const {
            name,
            disabled,
            placeholder,
            maxLength,
            minLength,
            onBlur,
            onMouseEnter,
            onMouseLeave,
            onKeyDown,
            customClassNames,
            customValidationMessage,
            fullColumn,
            showError,
            getErrorMessage,
            isFormSubmitted,
            validations,
            required,
            isValid,
            rows
        } = this.props;

        const errorMessage = getErrorMessage();

        // Required as div become uneven when message appended
        const fillerText = 'invisible filler text';

        const inputPlaceholder = required ? `* ${placeholder}` : placeholder || '';

        /* Validation states */
        let rootValidationClassname = '';
        const hasValidations = validations && Object.keys(validations).length > 0;

        if (!disabled && ((hasValidations && showError()) || customValidationMessage)) {
            rootValidationClassname += 'error';
        }

        if (isFormSubmitted()) {
            rootValidationClassname = isValid() && !customValidationMessage ? 'success' : 'error';
        }

        const messageClassNames = classNames('input-message');
        const inputClassNames = classNames('textarea', name);
        const filledClass = this.props.getValue() ? 'filled' : '';

        const inputElement = (
            <textarea
                className={inputClassNames}
                maxLength={maxLength}
                minLength={minLength}
                name={name}
                disabled={disabled}
                value={this.props.getValue() || ''}
                onBlur={onBlur}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onChange={this.onChange}
                onKeyDown={onKeyDown}
                rows={rows}
            />
        );

        const renderInputElement = (
            <div className={classNames('form-field form-field--custom', rootValidationClassname, filledClass)}>
                {inputElement}
                <label htmlFor={name} className="control-label">
                    {inputPlaceholder.toUpperCase()}
                </label>
                <div className={messageClassNames} dangerouslySetInnerHTML={{ __html: errorMessage || customValidationMessage || fillerText }} />
            </div>
        );

        return (
            <div className={classNames('form-field-wrapper', customClassNames)}>
                {renderInputElement}
                {fullColumn && <div className="clearfix" />}
            </div>
        );
    }

    static propTypes = {
        name: PropTypes.string,
        disabled: PropTypes.bool,
        maxLength: PropTypes.number,
        minLength: PropTypes.number,
        onBlur: PropTypes.func,
        onMouseLeave: PropTypes.func,
        onMouseEnter: PropTypes.func,
        // onChange: PropTypes.func,
        setValue: PropTypes.func,
        getValue: PropTypes.func,
        onKeyDown: PropTypes.func,
        placeholder: PropTypes.string,
        fullColumn: PropTypes.bool,
        customClassNames: PropTypes.string,
        customValidationMessage: PropTypes.string,
        showError: PropTypes.func,
        getErrorMessage: PropTypes.func,
        validations: PropTypes.object,
        isFormSubmitted: PropTypes.func,
        required: PropTypes.bool,
        isValid: PropTypes.func,
        rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    };

    static defaultProps = {
        name: '',
        type: '',
        rows: 4,
        disabled: false,
        maxLength: 100,
        minLength: 0,
        onBlur: () => {},
        onMouseLeave: () => {},
        onMouseEnter: () => {},
        onChange: () => {},
        onKeyDown: () => {},
        placeholder: '',
        fullColumn: false,
        showTooltip: false,
        toolTipMessage: '',
        disableAutoComplete: false,
        customClassNames: '',
        customValidationMessage: '',
        showError: () => {},
        getErrorMessage: () => {},
        validations: {},
        isFormSubmitted: () => {},
        required: false,
        isValid: () => {}
    };
}

export default withFormsy(TextArea);
